var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('iTable',{ref:"iTable",attrs:{"table-data":_vm.dataList,"columns":_vm.columns,"pagination":_vm.pagination,"tabletype":"4","other-height":230,"border":false},on:{"handleTableChange":_vm.handleTableChange,"openDetail":_vm.openDetail,"msgRead":_vm.msgRead}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }